import { Action, createReducer, on } from '@ngrx/store';
import { LoadingTypes } from 'src/app/shared/models/enums/loading.enum';
import {
    ScheduleOrientationPermissionState,
    ScheduleOrientationState
} from 'src/app/compliance/store/state/schedule-orientation.state';
import {
    loadScheduleOrientation,
    setScheduleOrientationDateForCandidate,
    setScheduleOrientation,
    loadScheduleOrientationSuccess,
    loadScheduleOrientationFail,
    setScheduleOrientationDateForCandidateSuccess,
    setScheduleOrientationDateForCandidateFail,
    setScheduleOrientationSuccess,
    setScheduleOrientationFail,
    addScheduleOrientationDateForCandidate,
    addScheduleOrientationDateForCandidateSuccess,
    addScheduleOrientationDateForCandidateFail,
    removeScheduleOrientation,
    removeScheduleOrientationSuccess,
    removeScheduleOrientationFail,
    loadFacilityScheduleOrientationPermission,
    loadFacilityScheduleOrientationPermissionSuccess,
    loadFacilityScheduleOrientationPermissionFail,
    loadScheduleOrientationSessions,
    loadScheduleOrientationSessionsFail,
    loadScheduleOrientationSessionsSuccess,
    loadScheduleOrientationSessionTypesFail,
    loadScheduleOrientationSessionTypes,
    loadScheduleOrientationSessionTypesSuccess,
    saveNewOrientation,
    saveNewOrientationSuccess,
    saveNewOrientationFail,
    cancelScheduleOrientation,
    cancelScheduleOrientationSuccess,
    cancelScheduleOrientationFail,
    setScheduleOrientationSessionDateForCandidateSuccess,
    addScheduleOrientationSessionDateForCandidateSuccess,
    setRescheduleScheduleOrientationSuccess,
    setRescheduleScheduleOrientationFail,
    setScheduleOrientationSessionDateForCandidateFail,
    addScheduleOrientationSessionDateForCandidateFail,
    setNoteScheduleOrientationSuccess,
    setNoteScheduleOrientationFail,
    setSendToMyAyaScheduleOrientationSuccess,
    setSendToMyAyaScheduleOrientationFail,
    setNoteScheduleOrientation,
    setSendToMyAyaScheduleOrientation,
    setRescheduleScheduleOrientation,
    setAskForNewAvailabilityScheduleOrientation,
    setAskForNewAvailabilityScheduleOrientationSuccess,
    setAskForNewAvailabilityScheduleOrientationFail,
    rescheduleOrientationDateSuccessCompleted,
    loadSessionsNextDay,
    loadSessionsNextDaySuccess,
    loadActionRequiredOrientationSessionsCount,
    loadActionRequiredOrientationSessionsCountSuccess,
    loadActionRequiredOrientationSessionsCountFail,
    setScheduleOrientationMultiDayForCandidate,
    setScheduleOrientationMultiDayForCandidateSuccess,
    setScheduleOrientationMultiDayForCandidateFail,
    multiDayAskForNewAvailabilityDates,
    multiDayAskForNewAvailabilityDatesFail,
    multiDayAskForNewAvailabilityDatesSuccess,
    loadSessionsNextDayFail,
    updatePresetDatesOfScheduleOrientation,
    updatePresetDatesOfScheduleOrientationFail,
    updatePresetDatesOfScheduleOrientationSuccess,
    updateNoteOfScheduleOrientation,
    updateNoteOfScheduleOrientationSuccess,
    updateNoteOfScheduleOrientationFail,
    loadMultiBundlesStatuses,
    loadMultiBundlesStatusesFail,
    loadMultiBundlesStatusesSuccess,
    updateScheduleOrientationAvailability,
    updateScheduleOrientationAvailabilitySuccess,
    updateScheduleOrientationAvailabilityFail,
    loadDoesAnyOrientationExist,
    loadDoesAnyOrientationExistFail,
    loadDoesAnyOrientationExistSuccess,
    rescheduleMultiDayOrientations,
    rescheduleMultiDayOrientationsSuccess,
    rescheduleMultiDayOrientationsFail,
    sendMultiDayOrientationToMyAya,
    sendMultiDayOrientationToMyAyaSuccess,
    sendMultiDayOrientationToMyAyaFail,
    resetFacilityScheduleOrientationPermission
} from 'src/app/compliance/store/actions/schedule-orientation.actions';

import { emptyPagingToken } from 'src/app/shared/models/core';
import { ScheduleOrientation } from 'src/app/compliance/models/schedule-orientation.model';
import { ScheduleOrientationStatusEnum } from 'src/app/compliance/enums/schedule-orientation-status.enum';

const initialState: ScheduleOrientationState = {
    scheduleOrientation: null,
    scheduleOrientationSessions: emptyPagingToken(),
    scheduleOrientationStatuses: [
        {
            id: ScheduleOrientationStatusEnum.ActionRequiredScheduleOrientation,
            name: 'Action required: Schedule orientation date'
        },
        {
            id: ScheduleOrientationStatusEnum.ActionRequiredAskCandidateAvailability,
            name: 'Action required: Ask candidate for availability'
        },
        {
            id: ScheduleOrientationStatusEnum.PendingCandidateAvailability,
            name: 'Pending candidate’s orientation availability'
        },
        {
            id: ScheduleOrientationStatusEnum.PendingCandidateConfirmation,
            name: 'Pending candidate’s confirmation'
        },
        {
            id: ScheduleOrientationStatusEnum.CandidateConfirmedOrientation,
            name: 'Confirmed orientation date'
        },
        {
            id: ScheduleOrientationStatusEnum.Cancelled,
            name: 'Canceled'
        }
    ],
    scheduleOrientationSessionTypes: [],
    loading: LoadingTypes.INIT,
    actionRequiredOrientationSessionsCount: 0,
    error: '',
    selectedScheduleOrientation: null,
    sessionsNeedsRefresh: true
};

const reducer = createReducer(
    initialState,

    on(loadScheduleOrientation, (state) => ({
        ...state,
        loading: LoadingTypes.LOADING,
        error: ''
    })),

    on(loadScheduleOrientationSuccess, (state, { scheduleOrientation }) => ({
        ...state,
        scheduleOrientation: scheduleOrientation,
        loading: LoadingTypes.LOADED,
        error: ''
    })),
    on(loadScheduleOrientationFail, (state, { error }) => ({
        ...state,
        scheduleOrientation: null,
        loading: LoadingTypes.FAIL,
        error: error
    })),

    on(loadScheduleOrientationSessions, (state) => ({
        ...state,
        loading: LoadingTypes.LOADING,
        error: ''
    })),

    on(loadScheduleOrientationSessionsSuccess, (state, { scheduleOrientationSessions }) => ({
        ...state,
        scheduleOrientationSessions: scheduleOrientationSessions,
        loading: LoadingTypes.LOADED,
        error: ''
    })),

    on(loadScheduleOrientationSessionsFail, (state, { error }) => ({
        ...state,
        scheduleOrientationSessions: { data: [], total: 0, filtered: 0 },
        loading: LoadingTypes.FAIL,
        error: error
    })),

    on(loadActionRequiredOrientationSessionsCount, (state) => ({
        ...state,
        loading: LoadingTypes.LOADING,
        error: ''
    })),

    on(loadActionRequiredOrientationSessionsCountSuccess, (state, { count }) => ({
        ...state,
        actionRequiredOrientationSessionsCount: count,
        loading: LoadingTypes.LOADED,
        error: ''
    })),

    on(loadActionRequiredOrientationSessionsCountFail, (state, { error }) => ({
        ...state,
        actionRequiredOrientationSessionsCount: 0,
        loading: LoadingTypes.FAIL,
        error: error
    })),

    on(loadScheduleOrientationSessionTypes, (state) => ({
        ...state,
        loading: LoadingTypes.LOADING,
        error: ''
    })),

    on(loadScheduleOrientationSessionTypesSuccess, (state, { scheduleOrientationSessionTypes }) => ({
        ...state,
        scheduleOrientationSessionTypes: scheduleOrientationSessionTypes,
        loading: LoadingTypes.LOADED,
        error: ''
    })),

    on(loadScheduleOrientationSessionTypesFail, (state, { error }) => ({
        ...state,
        scheduleOrientationSessionTypes: [],
        loading: LoadingTypes.FAIL,
        error: error
    })),

    on(setScheduleOrientationDateForCandidate, (state) => ({
        ...state,
        scheduleOrientation: null,
        loading: LoadingTypes.LOADING,
        error: ''
    })),

    on(setScheduleOrientationDateForCandidateSuccess, (state, { scheduleOrientation }) => ({
        ...state,
        scheduleOrientation: scheduleOrientation,
        loading: LoadingTypes.LOADED,
        error: ''
    })),
    on(setScheduleOrientationDateForCandidateFail, (state, { error }) => ({
        ...state,
        scheduleOrientation: null,
        loading: LoadingTypes.FAIL,
        error: error
    })),

    on(addScheduleOrientationDateForCandidate, (state) => ({
        ...state,
        scheduleOrientation: null,
        loading: LoadingTypes.LOADING,
        error: ''
    })),
    on(addScheduleOrientationDateForCandidateSuccess, (state, { scheduleOrientation }) => ({
        ...state,
        scheduleOrientation: scheduleOrientation,
        loading: LoadingTypes.LOADED,
        error: ''
    })),
    on(addScheduleOrientationDateForCandidateFail, (state, { error }) => ({
        ...state,
        scheduleOrientation: null,
        loading: LoadingTypes.FAIL,
        error: error
    })),

    on(setScheduleOrientation, (state) => ({
        ...state,
        scheduleOrientation: null,
        loading: LoadingTypes.LOADING,
        error: ''
    })),
    on(setScheduleOrientationSuccess, (state, { scheduleOrientation }) => ({
        ...state,
        scheduleOrientation: scheduleOrientation,
        loading: LoadingTypes.LOADED,
        error: ''
    })),
    on(setScheduleOrientationFail, (state, { error }) => ({
        ...state,
        scheduleOrientation: null,
        loading: LoadingTypes.FAIL,
        error: error
    })),
    on(removeScheduleOrientation, (state) => ({
        ...state,
        scheduleOrientation: null,
        loading: LoadingTypes.LOADING,
        error: ''
    })),
    on(removeScheduleOrientationSuccess, (state) => ({
        ...state,
        scheduleOrientation: null,
        loading: LoadingTypes.LOADED,
        error: ''
    })),
    on(removeScheduleOrientationFail, (state, { error }) => ({
        ...state,
        scheduleOrientation: null,
        loading: LoadingTypes.FAIL,
        error: error
    })),

    on(cancelScheduleOrientation, (state) => ({
        ...state,
        scheduleOrientation: null,
        loading: LoadingTypes.LOADING,
        error: ''
    })),

    on(saveNewOrientation, (state) => ({
        ...state,
        scheduleOrientation: null,
        loading: LoadingTypes.LOADING,
        error: ''
    })),

    on(saveNewOrientationSuccess, (state) => ({
        ...state,
        loading: LoadingTypes.LOADED,
        error: ''
    })),
    on(saveNewOrientationFail, (state, { error }) => ({
        ...state,
        loading: LoadingTypes.FAIL,
        error: error
    })),
    on(cancelScheduleOrientationSuccess, (state, { scheduleOrientation }): ScheduleOrientationState => {
        const newScheduleOrientationSessions = state.scheduleOrientationSessions.data.map((x) =>
            x.scheduleOrientationId === scheduleOrientation.scheduleOrientationId ? scheduleOrientation : x
        );

        const scheduleOrientationSessions = {
            ...state.scheduleOrientationSessions,
            data: newScheduleOrientationSessions
        };

        return {
            ...state,
            scheduleOrientationSessions: scheduleOrientationSessions,
            loading: LoadingTypes.LOADED,
            error: ''
        };
    }),
    on(cancelScheduleOrientationFail, (state, { error }) => ({
        ...state,
        scheduleOrientation: null,
        loading: LoadingTypes.FAIL,
        error: error
    })),
    on(setScheduleOrientationSessionDateForCandidateSuccess, (state, action) =>
        handleScheduleOrientationToReplace(state, action.scheduleOrientation)
    ),
    on(setScheduleOrientationSessionDateForCandidateFail, (state, { error }) => ({
        ...state,
        loading: LoadingTypes.FAIL,
        error: error
    })),
    on(addScheduleOrientationSessionDateForCandidateSuccess, (state, action) =>
        handleScheduleOrientationToReplace(state, action.scheduleOrientation)
    ),
    on(addScheduleOrientationSessionDateForCandidateFail, (state, { error }) => ({
        ...state,
        loading: LoadingTypes.FAIL,
        error: error
    })),
    on(setRescheduleScheduleOrientation, (state) => ({
        ...state,
        loading: LoadingTypes.LOADING,
        error: '',
        sessionsNeedsRefresh: true
    })),
    on(setRescheduleScheduleOrientationSuccess, (state, action) =>
        handleReScheduleOrientationToReplace(state, action.scheduleOrientation)
    ),
    on(setRescheduleScheduleOrientationFail, (state, { error }) => ({
        ...state,
        loading: LoadingTypes.FAIL,
        error: error,
        selectedScheduleOrientation: null
    })),
    on(setAskForNewAvailabilityScheduleOrientation, (state) => ({
        ...state,
        loading: LoadingTypes.LOADING,
        error: ''
    })),
    on(setAskForNewAvailabilityScheduleOrientationSuccess, (state, action) =>
        handleScheduleOrientationToReplace(state, action.scheduleOrientation)
    ),
    on(setAskForNewAvailabilityScheduleOrientationFail, (state, { error }) => ({
        ...state,
        loading: LoadingTypes.FAIL,
        error: error
    })),
    on(setNoteScheduleOrientation, (state) => ({
        ...state,
        loading: LoadingTypes.LOADING,
        error: ''
    })),
    on(setNoteScheduleOrientationSuccess, (state, action) =>
        handleScheduleOrientationToChangeNote(state, action.scheduleOrientationId, action.note)
    ),
    on(setNoteScheduleOrientationFail, (state, { error }) => ({
        ...state,
        loading: LoadingTypes.FAIL,
        error: error
    })),
    on(setSendToMyAyaScheduleOrientation, (state) => ({
        ...state,
        loading: LoadingTypes.LOADING,
        error: ''
    })),
    on(setSendToMyAyaScheduleOrientationSuccess, (state, action) =>
        handleScheduleOrientationToReplace(state, action.scheduleOrientation)
    ),
    on(setSendToMyAyaScheduleOrientationFail, (state, { error }) => ({
        ...state,
        loading: LoadingTypes.FAIL,
        error: error
    })),
    on(rescheduleOrientationDateSuccessCompleted, (state) => ({
        ...state,
        selectedScheduleOrientation: null,
        sessionsNeedsRefresh: true
    })),
    on(loadSessionsNextDay, (state) => ({
        ...state,
        sessionsNextDay: null,
        loading: LoadingTypes.LOADING,
        error: ''
    })),
    on(loadSessionsNextDaySuccess, (state, { day }) => ({
        ...state,
        sessionsNextDay: day,
        loading: LoadingTypes.LOADED,
        error: ''
    })),
    on(loadSessionsNextDayFail, (state, { error }) => ({
        ...state,
        loading: LoadingTypes.FAIL,
        error: error
    })),
    on(loadDoesAnyOrientationExist, (state) => ({
        ...state,
        doesAnyOrientationExist: null,
        loading: LoadingTypes.LOADING,
        error: ''
    })),
    on(loadDoesAnyOrientationExistSuccess, (state, { result }) => ({
        ...state,
        doesAnyOrientationExist: result,
        loading: LoadingTypes.LOADED,
        error: ''
    })),
    on(loadDoesAnyOrientationExistFail, (state, { error }) => ({
        ...state,
        loading: LoadingTypes.FAIL,
        error: error
    })),
    on(loadMultiBundlesStatuses, (state) => ({
        ...state,
        multiBundlesStatuses: null,
        loading: LoadingTypes.LOADING,
        error: ''
    })),
    on(loadMultiBundlesStatusesSuccess, (state, { multiBundleStatuses: multiBundleStatus }) => ({
        ...state,
        multiBundlesStatuses: multiBundleStatus,
        loading: LoadingTypes.LOADED,
        error: ''
    })),
    on(loadMultiBundlesStatusesFail, (state, { error }) => ({
        ...state,
        loading: LoadingTypes.FAIL,
        error: error
    })),

    on(updateScheduleOrientationAvailability, (state) => ({
        ...state,
        loading: LoadingTypes.LOADING,
        error: '',
        sessionsNeedsRefresh: false
    })),
    on(updateScheduleOrientationAvailabilitySuccess, (state, action) =>
        handleReScheduleOrientationToReplace(state, action.scheduleOrientation)
    ),
    on(updateScheduleOrientationAvailabilityFail, (state, { error }) => ({
        ...state,
        loading: LoadingTypes.FAIL,
        error: error
    })),

    on(setScheduleOrientationMultiDayForCandidate, (state) => ({
        ...state,
        loading: LoadingTypes.LOADING,
        error: ''
    })),
    on(setScheduleOrientationMultiDayForCandidateSuccess, (state, action) =>
        handleScheduleOrientationToReplace(state, action.scheduleOrientations)
    ),
    on(setScheduleOrientationMultiDayForCandidateFail, (state, { error }) => ({
        ...state,
        loading: LoadingTypes.FAIL,
        error: error
    })),

    on(multiDayAskForNewAvailabilityDates, (state) => ({
        ...state,
        loading: LoadingTypes.LOADING,
        error: '',
        sessionsNeedsRefresh: false
    })),
    on(multiDayAskForNewAvailabilityDatesSuccess, (state, action) =>
        handleReScheduleOrientationToReplace(state, action.scheduleOrientation)
    ),
    on(multiDayAskForNewAvailabilityDatesFail, (state, { error }) => ({
        ...state,
        loading: LoadingTypes.FAIL,
        error: error
    })),

    on(updatePresetDatesOfScheduleOrientation, (state) => ({
        ...state,
        loading: LoadingTypes.LOADING,
        error: '',
        sessionsNeedsRefresh: false
    })),
    on(updatePresetDatesOfScheduleOrientationSuccess, (state, action) =>
        handleReScheduleOrientationToReplace(state, action.scheduleOrientation)
    ),
    on(updatePresetDatesOfScheduleOrientationFail, (state, { error }) => ({
        ...state,
        loading: LoadingTypes.FAIL,
        error: error
    })),
    on(updateNoteOfScheduleOrientation, (state) => ({
        ...state,
        loading: LoadingTypes.LOADING,
        error: '',
        sessionsNeedsRefresh: false
    })),
    on(updateNoteOfScheduleOrientationSuccess, (state, action) =>
        handleReScheduleOrientationToReplace(state, action.scheduleOrientation)
    ),
    on(updateNoteOfScheduleOrientationFail, (state, { error }) => ({
        ...state,
        loading: LoadingTypes.FAIL,
        error: error
    })),
    on(rescheduleMultiDayOrientations, (state) => ({
        ...state,
        loading: LoadingTypes.LOADING,
        error: '',
        sessionsNeedsRefresh: true
    })),
    on(rescheduleMultiDayOrientationsSuccess, (state, action) =>
        handleReScheduleOrientationToReplace(state, action.scheduleOrientation)
    ),
    on(rescheduleMultiDayOrientationsFail, (state, { error }) => ({
        ...state,
        loading: LoadingTypes.FAIL,
        error: error,
        selectedScheduleOrientation: null
    })),
    on(sendMultiDayOrientationToMyAya, (state) => ({
        ...state,
        loading: LoadingTypes.LOADING,
        error: '',
        sessionsNeedsRefresh: false
    })),
    on(sendMultiDayOrientationToMyAyaSuccess, (state, action) =>
        handleScheduleOrientationToReplace(state, action.scheduleOrientation)
    ),
    on(sendMultiDayOrientationToMyAyaFail, (state, { error }) => ({
        ...state,
        loading: LoadingTypes.FAIL,
        error: error
    }))
);

export function scheduleOrientationReducer(state: ScheduleOrientationState | undefined, action: Action) {
    return reducer(state, action);
}

const initialPermissionState: ScheduleOrientationPermissionState = {
    orientationPermissionId: null,
    loading: LoadingTypes.INIT,
    error: ''
};

const permissionReducer = createReducer(
    initialPermissionState,

    on(loadFacilityScheduleOrientationPermission, (state) => ({
        ...state,
        orientationPermissionId: null,
        loading: LoadingTypes.LOADING,
        error: ''
    })),
    on(loadFacilityScheduleOrientationPermissionSuccess, (state, { orientationPermissionId }) => ({
        ...state,
        orientationPermissionId: orientationPermissionId,
        loading: LoadingTypes.LOADED,
        error: ''
    })),
    on(loadFacilityScheduleOrientationPermissionFail, (state, { error }) => ({
        ...state,
        orientationPermissionId: null,
        loading: LoadingTypes.FAIL,
        error: error
    })),

    on(resetFacilityScheduleOrientationPermission, (state) => ({
        ...state,
        orientationPermissionId: null
    }))
);

export function scheduleOrientationPermissionReducer(
    state: ScheduleOrientationPermissionState | undefined,
    action: Action
) {
    return permissionReducer(state, action);
}

export function handleScheduleOrientationToReplace(
    state: ScheduleOrientationState,
    scheduleOrientation: ScheduleOrientation
): ScheduleOrientationState {
    let updateData: ScheduleOrientation[] = [];

    if (scheduleOrientation.scheduleOrientationSessionTypeId < 4) {
        updateData = simpleMapAdHocOrientation(state, scheduleOrientation);
    } else {
        const result = complexMapMultiDayOrientation(state, scheduleOrientation);
        updateData = result.updateData;
    }

    return {
        ...state,
        scheduleOrientationSessions: {
            ...state.scheduleOrientationSessions,
            data: updateData
        },
        loading: LoadingTypes.LOADED,
        error: ''
    };
}

export function handleReScheduleOrientationToReplace(
    state: ScheduleOrientationState,
    scheduleOrientation: ScheduleOrientation
): ScheduleOrientationState {
    let updateData: ScheduleOrientation[] = [];

    if (scheduleOrientation.scheduleOrientationSessionTypeId < 4) {
        updateData = simpleMapAdHocOrientation(state, scheduleOrientation);
    } else {
        const result = complexMapMultiDayOrientation(state, scheduleOrientation);
        updateData = result.updateData;
        scheduleOrientation = result.selectedOrientation;
    }

    return {
        ...state,
        scheduleOrientationSessions: {
            ...state.scheduleOrientationSessions,
            data: updateData
        },
        loading: LoadingTypes.LOADED,
        error: '',
        selectedScheduleOrientation: scheduleOrientation
    };
}

function handleScheduleOrientationToChangeNote(
    state: ScheduleOrientationState,
    scheduleOrientationId: number,
    note: string
): ScheduleOrientationState {
    const updateData = state.scheduleOrientationSessions.data.map((sch) => {
        if (sch.scheduleOrientationId !== scheduleOrientationId) {
            return sch;
        }

        return {
            ...sch,
            note: note
        };
    });

    return {
        ...state,
        scheduleOrientationSessions: {
            ...state.scheduleOrientationSessions,
            data: updateData
        },
        loading: LoadingTypes.LOADED,
        error: ''
    };
}

function simpleMapAdHocOrientation(
    state: ScheduleOrientationState,
    scheduleOrientation: ScheduleOrientation
): ScheduleOrientation[] {
    return state.scheduleOrientationSessions.data.map((sch) =>
        sch.scheduleOrientationId !== scheduleOrientation.scheduleOrientationId ? sch : scheduleOrientation
    );
}

function complexMapMultiDayOrientation(
    state: ScheduleOrientationState,
    scheduleOrientation: ScheduleOrientation
): { updateData: ScheduleOrientation[]; selectedOrientation: ScheduleOrientation } {
    const orientationId = scheduleOrientation.scheduleOrientationId;
    const updateData: ScheduleOrientation[] = [];
    let selectedOrientation: ScheduleOrientation;

    for (const sch of state.scheduleOrientationSessions.data) {
        if (sch.scheduleOrientationId === orientationId) {
            updateData.push(scheduleOrientation);
            selectedOrientation = { ...scheduleOrientation };
        } else if (sch.scheduleOrientationSessionTypeId < 4) {
            updateData.push(sch);
        } else {
            const result = handleMultiDayOrientations(sch, orientationId, scheduleOrientation);
            updateData.push(result.sch);

            if (result.selectedSch) {
                selectedOrientation = result.sch;
            }
        }
    }

    return { updateData, selectedOrientation };
}

function handleMultiDayOrientations(
    sch: ScheduleOrientation,
    orientationId: number,
    scheduleOrientation: ScheduleOrientation
): { sch: ScheduleOrientation; selectedSch: boolean } {
    const index = sch.multiDayScheduleOrientations.findIndex((x) => x.scheduleOrientationId === orientationId);
    if (index >= 0) {
        const updatedOrientations = [...sch.multiDayScheduleOrientations];
        updatedOrientations[index] = { ...scheduleOrientation };
        return {
            sch: {
                ...sch,
                multiDayScheduleOrientations: updatedOrientations
            },
            selectedSch: true
        };
    }
    return { sch, selectedSch: false };
}
